
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.264.2c2.16 0 3.24 0 4.416.36a4.54 4.54 0 012.736 2.736c.384 1.2.384 2.28.384 4.44v6.528c0 2.16 0 3.24-.36 4.416a4.54 4.54 0 01-2.736 2.736c-1.176.384-2.256.384-4.44.384H7.736c-2.16 0-3.24 0-4.416-.36-1.272-.48-2.28-1.464-2.736-2.76C.2 17.528.2 16.448.2 14.264V7.736c0-2.16 0-3.24.36-4.416A4.64 4.64 0 013.32.584C4.496.2 5.576.2 7.736.2h6.528z","fill":"url(#phone_icon_svg__paint0_linear_861_50500)"}}),_c('path',{attrs:{"d":"M5.168 9.632c-.792-1.44-1.104-2.616-1.104-3.408 0-.792.192-1.008.384-1.2.192-.192 1.08-.72 1.248-.84.144-.096.72-.312 1.08.216.36.528 1.032 1.56 1.512 2.256.744.984.144 1.416-.048 1.68-.36.48-.552.6-.552 1.176s1.632 2.256 2.016 2.664c.384.408 2.016 1.824 2.52 1.92.505.072 1.2-.456 1.345-.6.743-.576 1.151-.144 1.487.048a98.99 98.99 0 012.353 1.464c.456.312.408.816.408.816s-.313.936-1.032 1.632c-.169.168-.48.384-1.225.384-.744 0-1.56-.144-3.48-1.2-1.56-.864-3.048-2.208-3.84-3-.792-.768-2.16-2.352-3.072-4.008z","fill":"#fff"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"phone_icon_svg__paint0_linear_861_50500","x1":"11.01","y1":".21","x2":"11.01","y2":"21.795","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#67FF81"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#01B41F"}})])])])
          )
        }
      }
    